import axios from '../services/axios';
import {
  getPotsConfig,
  getTransactionTimestamp,
  getOrderId,
  getPaymentKioskId
} from '../services/paymentKiosk';
import { isEmpty } from '../helpers/paymentKiosk';
import { toBool } from '../reducers/configReducer';

export const POTS_API_POLLING_TIMEOUT_MS = 1000;
export const POTS_API_SIMULATION_DELAY = 2000;

export const PATRON_ID = 'DISPENSARY';

export const PAYMENT_STATUS = {
  ABORTED: 'Aborted',
  COMPLETED: 'Completed',
  PENDING: 'Pending',
  OPEN: 'Open',
  TIMEOUT: 'Timeout',
};

export const PAYMENT_TYPE = {
  NONE: 'None',
  CASH: 'Cash',
  CARD: 'Card',
  COUPON: 'Coupon'
};

function authHeader(token) {
  return {
    headers: {
      Authentication: `Bearer ${token}`,
      'Content-Type': 'application/json;charset=UTF-8'
    }
  };
}

export async function addPayment(amount) {
  const {
    url,
    token,
    requestorID,
    description,
    confirmationDeliveryMethod,
    currentFlag
  } = getPotsConfig();

  const paymentKioskId = getPaymentKioskId();

  if (isEmpty(paymentKioskId)) {
    return Promise.reject(new Error('Unknown paymentKioskId'));
  }

  const alphaNumId = getOrderId();
  const transactionTimestamp = getTransactionTimestamp();

  if (!toBool(currentFlag)) {
    /** simulate pots */
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          data: {
            potsTid: '000000354'
          }
        });
      }, POTS_API_SIMULATION_DELAY);
    });
  }

  return axios
    .post(
      `${url}/api/payment`,
      {
        "requestorID": requestorID,
        "requestorTID": alphaNumId,
        "kioskID": paymentKioskId,
        "amount": Number(amount).toFixed(2),
        "patronID": PATRON_ID,
        "description": description,
        "transactionTimestamp": transactionTimestamp,
        "confirmationDeliveryMethod": confirmationDeliveryMethod
      },
      authHeader(token)
    );
}

export async function updatePayment(potsTid, paymentData) {
  const {
    url,
    token,
    requestorID,
    currentFlag
  } = getPotsConfig();

  if (!toBool(currentFlag)) {
    /** simulate pots */
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          data: { Status: 'accepted' }
        });
      }, POTS_API_SIMULATION_DELAY);
    });
  }

  return axios
    .put(
      `${url}/api/requestor/${requestorID}/payment/${potsTid}`,
      paymentData,
      authHeader(token)
    );
}

export async function getPaymentStatus(potsTid) {
  const {
    url,
    token,
    requestorID,
    currentFlag
  } = getPotsConfig();

  if (!toBool(currentFlag)) {
    /** simulate pots api */
    const paymentStatuses = [PAYMENT_STATUS.PENDING, PAYMENT_STATUS.OPEN, PAYMENT_STATUS.COMPLETED, PAYMENT_STATUS.ABORTED];

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          data: {
            paymentStatus: paymentStatuses[getRandomInt(0, paymentStatuses.length - 1)]
          }
        });
      }, POTS_API_SIMULATION_DELAY);
    });
  }

  return axios
    .get(
      `${url}/api/requestor/${requestorID}/payment/${potsTid}/status`,
      authHeader(token)
    );
}

export async function getPaymentSummary(potsTid) {
  const {
    url,
    token,
    requestorID,
    currentFlag
  } = getPotsConfig();

  if (!toBool(currentFlag)) {
    /** simulate pots api */
    const paymentStatuses = [PAYMENT_STATUS.PENDING, PAYMENT_STATUS.OPEN, PAYMENT_STATUS.COMPLETED, PAYMENT_STATUS.ABORTED];
    const paymentTypes = [PAYMENT_TYPE.CASH, PAYMENT_TYPE.CARD];

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          data: {
            paymentStatus: paymentStatuses[getRandomInt(0, paymentStatuses.length - 1)],
            paidBy: [
              {
                method: paymentTypes[getRandomInt(0, paymentTypes.length - 1)],
                amount: 0.0
              }
            ]
          }
        });
      }, POTS_API_SIMULATION_DELAY);
    });
  }

  return axios
    .get(
      `${url}/api/requestor/${requestorID}/payment/${potsTid}/summary`,
      authHeader(token)
    );
}

export async function getKioskSettings() {
  // Temporarily return empty settings
  return new Promise((resolve, reject) => {
    resolve({
      data: {
      }
    });
  });
}

async function pollPaymentStatus(potsTid) {
  let attempt = 0;
  const attempMax = 500;

  return new Promise((resolve, reject) => {
    const callInverval = setInterval(async () => {
      console.log('Checking the api...');
      const responseStatus = await getPaymentStatus(potsTid);
      const paymentStatus = responseStatus.data.paymentStatus;
      console.log('Got response! ', responseStatus);

      if (attempt === attempMax) {
        clearInterval(callInverval);
        console.log('Attemps exceed');
        resolve(PAYMENT_STATUS.TIMEOUT);
        return;
      }

      if (paymentStatus === PAYMENT_STATUS.ABORTED || paymentStatus === PAYMENT_STATUS.COMPLETED) {
        clearInterval(callInverval);
        resolve(paymentStatus);
      }

      attempt++;
    }, POTS_API_POLLING_TIMEOUT_MS);
  });
}

export async function addPaymentAndGetStatus(amountToPay) {
  const addPaymentResult = await addPayment(amountToPay);

  const potsTid = addPaymentResult.data.potsTid;

  const paymentStatusResult = await pollPaymentStatus(potsTid);

  return {
    potsTid: potsTid,
    status: paymentStatusResult
  };
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}



// WEBPACK FOOTER //
// ./src/actions/pots-api.js